// dependencies
import React from "react";
import { View, Text, StyleSheet, TouchableWithoutFeedback } from "react-native";
import {
  IconStepBackward,
  IconCaretLeftO,
  IconCaretRightO,
  IconStepForward,
} from "@cloudspire/legacy-svg-icon-library";
import { useIntl } from "react-intl";

// hocs
import withHover from "../../../hocs/withHover";

// components
import Link from "../../Link";

// libraries
import { emToPx } from "../../../libraries";

import theming from "../../../constants/theming";

const { useTheme } = theming;

const styles = StyleSheet.create({
  button: {
    cursor: "pointer",
  },
  button__hover: {
    backgroundColor: "#edf1f2",
  },
  button__disabled: {
    backgroundColor: "#edf1f2",
    color: "#bbb",
  },
  link: {
    padding: emToPx(1),
    lineHeight: 0,
  },
  link__disabled: {
    cursor: "not-allowed",
  },
  icon: {
    fontSize: emToPx(1),
  },
});

const PaginationButton = (props) => {
  const { to, type, hovered, disabled, onPress, ...otherProps } = props;

  const theme = useTheme();
  const intl = useIntl();

  let Icon;
  let label;
  switch (type) {
    case "backward": {
      Icon = IconStepBackward;
      label = intl.formatMessage({
        defaultMessage: "Première page",
      });
      break;
    }
    case "forward": {
      Icon = IconStepForward;
      label = intl.formatMessage({
        defaultMessage: "Dernière page",
      });
      break;
    }
    case "next": {
      Icon = IconCaretRightO;
      label = intl.formatMessage({
        defaultMessage: "Page suivante",
      });
      break;
    }
    case "previous": {
      Icon = IconCaretLeftO;
      label = intl.formatMessage({
        defaultMessage: "Page précédente",
      });
      break;
    }
  }

  return (
    <View {...otherProps}>
      <TouchableWithoutFeedback
        disabled={disabled}
        onPress={onPress}
        accessible={false}
      >
        <View
          style={[
            styles.button,
            hovered && styles.button__hover,
            disabled && styles.button__disabled,
          ]}
        >
          {disabled ? (
            <Text
              accessibilityLabel={label}
              style={[
                styles.link,
                { fontSize: emToPx(theme.FONT_SIZE / 16) },
                styles.link__disabled,
              ]}
              aria-disabled={true}
            >
              <Text style={styles.icon}>
                <Icon style={{ strokeWidth: 2 }} />
              </Text>
            </Text>
          ) : (
            <>
              {undefined !== to ? (
                <Link
                  accessibilityLabel={label}
                  style={[
                    styles.link,
                    { fontSize: emToPx(theme.FONT_SIZE / 16) },
                  ]}
                  to={to}
                >
                  <Text style={styles.icon}>
                    <Icon style={{ strokeWidth: 2 }} />
                  </Text>
                </Link>
              ) : (
                <Text
                  accessibilityLabel={label}
                  style={[
                    styles.link,
                    { fontSize: emToPx(theme.FONT_SIZE / 16) },
                  ]}
                >
                  <Text style={styles.icon}>
                    <Icon style={{ strokeWidth: 2 }} />
                  </Text>
                </Text>
              )}
            </>
          )}
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

export default withHover(PaginationButton);
